module.exports = __webpack_public_path__ + "img/NI.32e4d1fe.svg";